import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getRoleListApi } from "../../api/roleApi";
import DateFormat from "../../utils/DateFormat";
import { FaEye, FaEdit } from "react-icons/fa";

const RoleList = () => {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getRoleListApi(page, limit);
      if (response?.success === false) {
        setError(response?.message || "Failed to fetch roles");

        return;
      }

      const roleData = response?.data?.roles || response?.data || [];

      setRoles(Array.isArray(roleData) ? roleData : []);

      setTotalItems(
        response?.data?.totalItems || response?.data?.total || response?.totalItems || 0,
      );
    } catch (error) {
      console.error(error);

      setRoles([]);

      setError(error?.response?.data?.message || "Failed to fetch roles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [page]);

  const totalPages = Math.ceil(totalItems / limit);

  return (
    <div className="container-fluid p-4 np-roles-page">
      {/* Header */}
      <div className="card p-3">
        <div className="d-flex justify-content-end align-items-center mb-3">
          <button type="button" className="btn btn-primary" onClick={() => navigate("/role/add")}>
            + Add Role
          </button>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* Table */}
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" />

              <p className="mt-3 mb-0">Loading roles...</p>
            </div>
          ) : roles.length === 0 ? (
            <div className="text-center py-5">
              <h6>No roles found</h6>

              <p className="text-muted mb-0">No roles are available.</p>
            </div>
          ) : (
            <table className="table table-bordered table-hover">
              <thead className="bg-light">
                <tr>
                  <th className="text-dark fw-bold">#</th>
                  <th className="text-dark fw-bold">Role Name</th>
                  <th className="text-dark fw-bold">Status</th>
                  <th className="text-dark fw-bold">Created At</th>
                  <th className="text-dark text-center fw-bold">Action</th>
                </tr>
              </thead>

              <tbody>
                {roles.map((role, index) => (
                  <tr key={role?._id || index}>
                    <td>{(page - 1) * limit + index + 1}</td>

                    <td>
                      <p className="mb-0">{role?.name || role?.roleName || "-"}</p>
                    </td>

                    <td>
                      {role?.status ? (
                        <span
                          className={`badge ${
                            role.status === "ACTIVE" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {role.status}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      <DateFormat date={role?.createdAt} />
                    </td>

                    <td>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm np-table-action-btn"
                          title="View"
                          onClick={() =>
                            navigate(`/role-view/${role.name}`, { state: { roleId: role._id } })
                          }
                        >
                          <FaEye />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm np-table-action-btn"
                          title="Edit"
                          onClick={() =>
                            navigate(`/role-edit/${role.name}`, {
                              state: { roleId: role._id },
                            })
                          }
                        >
                          <FaEdit />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleList;